import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RiArrowDownSFill } from "react-icons/ri";
import { Link } from "react-router-dom";

import useInView from "../../hooks/useInView";

const OverviewItem = ({ data, index, setCurrentIndex }) => {
  const [setRef, visible] = useInView({
    threshold: 1,
  });
  const { t } = useTranslation("home");

  useEffect(() => {
    if (visible) {
      setCurrentIndex(index);
    }
  }, [index, setCurrentIndex, visible]);

  const [expanded, setExpanded] = React.useState(false);

  const handleChangeAccordion = (panel) => () => {
    setExpanded((current) => (current === panel ? false : panel));
  };

  return (
    <article className="border-b border-slate-200 py-10 first:pt-0 lg:min-h-[78vh] lg:py-16">
      <div className="flex flex-col items-center gap-8 lg:items-start">
        <div className="flex flex-col items-center gap-5 text-center lg:items-start lg:text-left">
          {/* <div
            className="inline-flex rounded-full border border-sky-100 bg-sky-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-sky-600"
            ref={setRef}
          >
            {String(index + 1).padStart(2, "0")}
          </div> */}
          <h3
            className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl"
            ref={setRef}
          >
            {data.header}
          </h3>
          <img
            alt={data.header}
            className="w-full rounded-[1.5rem] border border-slate-200 object-cover shadow-sm lg:hidden"
            src={data.image}
          />
          <p className="text-base leading-8 text-slate-600 sm:text-lg">
            {data.content}
          </p>
        </div>

        {data.path ? (
          <Link
            className="inline-flex items-center rounded-full bg-sky-500 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-sky-600"
            to={data.path}
          >
            {t("overview.action")}
          </Link>
        ) : (
          <span className="inline-flex rounded-full bg-slate-100 px-5 py-3 text-sm font-semibold text-slate-500">
            {t("overview.wipLabel")}
          </span>
        )}

        {data.children?.length ? (
          <div className="w-full space-y-2">
            <p className="text-sm font-medium uppercase tracking-[0.18em] text-slate-500">
              {t("overview.relatedLabel")}
            </p>
            {data.children.map((child) => {
              const isOpen = expanded === child.header;

              return (
                <div
                  className="overflow-hidden rounded-2xl border border-slate-200 bg-slate-50/70"
                  key={child.header}
                >
                  <button
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    onClick={handleChangeAccordion(child.header)}
                    type="button"
                  >
                    <span className="text-lg font-semibold text-slate-900">
                      {child.header}
                    </span>
                    <RiArrowDownSFill
                      className={`shrink-0 text-2xl text-sky-600 transition ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {isOpen ? (
                    <div className="space-y-4 border-t border-slate-200 px-5 py-5">
                      <img
                        alt={child.header}
                        className="w-full max-w-xs rounded-xl border border-slate-200 bg-white"
                        src={child.image}
                      />
                      <p className="text-sm leading-7 text-slate-600 sm:text-base">
                        {child.content}
                      </p>
                      {child.path ? (
                        <Link
                          className="inline-flex items-center rounded-full bg-sky-500 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-sky-600"
                          to={child.path}
                        >
                          {t("overview.action")}
                        </Link>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    </article>
  );
};

export default OverviewItem;
